import { useAppScopeStore } from '@frontend/scope';
import { PaymentSettingsGroup } from '../atoms/payment-settings-group';
import { PaymentSettingsCard } from '../atoms/payments-card';
import { PublicBusinessInformation } from '../sections/public-business-information';

export const PublicBusinessInformationGroup = () => {
  const { selectedLocationIds: locationIds } = useAppScopeStore();
  return (
    <section>
      {locationIds.length === 1 ? (
        <PaymentSettingsCard locationId={locationIds[0]}>
          <PublicBusinessInformation />
        </PaymentSettingsCard>
      ) : (
        <PaymentSettingsGroup showManageAllToggle>
          <PublicBusinessInformation />
        </PaymentSettingsGroup>
      )}
    </section>
  );
};
